<template>
   <div> 
     <b-col xs=8 lg=8 md=12 sm=12 >
    <h2 class="bronzeclaro">Contato</h2>
    <p>Obrigado pelo seu interesse nas nossas soluções!</p>
    <!-- <p>Entre em contato pelo nosso e-mail:</p>
    <p>contato @ lucchese.com.br</p> -->
    <p>Preencha o formulário abaixo e retornaremos para o seu e-mail ou telefone.</p>
    <ValidationObserver ref="observer">
      <!--@submit="onSubmit" @reset="onReset" v-if="show" 
        <b-form-invalid-feedback>
          {{ errors[0] }}
        </b-form-invalid-feedback>-->
    <b-form 
    slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" @reset="onReset"
    >
      <ValidationProvider rules="required|alpha_spaces" name="Name">
      <b-form-group id="input-group-1" label="Nome*:" label-for="input-1" slot-scope="{ valid, errors }">
        <b-form-input id="input-1" v-model="form.name" required placeholder="Seu nome"
        :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group>
      </ValidationProvider>

      <ValidationProvider rules="required|email" name="Email">
      <b-form-group
        id="input-group-2"
        label="E-mail*:"
        label-for="input-2"
        slot-scope="{ valid, errors }"
      >
        <b-form-input
          id="input-2"
          v-model="form.email"
          type="email"
          required
          placeholder="Endereço de e-mail"
          :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group>
      </ValidationProvider>

      <ValidationProvider rules="alpha_num" name="Telefone">
      <b-form-group id="input-group-3" label="Telefone:" label-for="input-3" slot-scope="{ valid, errors }"> 
      <!-- description="."> -->
        <b-form-input id="input-3" v-model="form.tel" type="tel" placeholder="Telefone ou celular"
        :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group>
      </ValidationProvider>

<!--       <b-form-group id="input-group-4" label-for="input-4" >
        <b-form-radio
          v-model="form.ligacao"
          name="some-radios"
          value="A"
        >Prefiro o retorno do contato por ligação telefônica.</b-form-radio>
        <b-form-radio
          v-model="form.ligacao"
          name="some-radios"
          value="B"
        >Prefiro o retorno do contato por mensagem de WhatsApp.</b-form-radio>
      </b-form-group> -->

      
      <b-form-group id="input-group-5" label-for="input-5" label="Motivo do contato*:" required>
        <b-form-radio v-model="form.porque" name="select2" value="ORCAMENTO">Pedido de orçamento</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="DUVIDA">Dúvida</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="SUGESTAO">Sugestão</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="OUTLUC">Outros</b-form-radio>
      </b-form-group>
      

      <ValidationProvider rules="required|alpha_spaces|max:100" name="AssuntoTexto">
      <b-form-group id="input-group-6" label="Assunto*:" label-for="input-6" slot-scope="{ valid, errors }">
        <b-form-input
          required
          id="input-6"
          v-model="form.assunto"
          type="text"
          placeholder="Assunto do seu contato"
          :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group>
      </ValidationProvider>

      <!-- <b-form-group id="input-group-7"  label="Texto*:" label-for="input-7">
        <b-form-input
          required
          id="input-7"
          v-model="form.text"
          type="text"
          placeholder="Texto"
        ></b-form-input>
      </b-form-group> -->
      Texto*:
      <ValidationProvider rules="required|max:1000" name="TextoTexto">
      <b-form-textarea
       slot-scope="{ valid, errors }"
       id="textarea"
       v-model="form.text"
       placeholder="Máximo: 1000 caracteres"
       rows="3"
       max-rows="6"
       required
       :state="errors[0] ? false : (valid ? true : null)"
      ></b-form-textarea>
      </ValidationProvider>

      <div>
        <h1></h1>
      </div>

      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        sitekey="6LcK9McZAAAAAABhQ_5Nhm8UPkj008KIQp0SDBqA"
        size="invisible"
      ></vue-recaptcha>

      <div>
        <h1></h1>
      </div>

      <b-row>
        <b-col class="text-center">
                  <b-button :disabled="sending" type="submit" pill variant="warning">Enviar</b-button>
        </b-col>
        <b-col class="text-center">
                  <b-button type="reset" pill variant="warning" >Limpar</b-button>
        </b-col>
      </b-row>
    </b-form>
    </ValidationObserver>
    <div>
        <h1></h1>
    </div>
    <!--- -->
<!--     <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre> 
    </b-card> -->
   </b-col>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueRecaptcha from "vue-recaptcha";
import api from "../services/api";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        tel: "",
        text:"",
        assunto:"",
        // ligacao: "",
        porque: "ORCAMENTO",
      },
      show: true,
      sending: false
    };
  },
  methods: {
    onSubmit () {
      this.sending = true;
      this.$refs.recaptcha.execute();
      console.log(JSON.stringify(this.form));
      //alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.tel = "";
      this.form.text = "";
      this.form.assunto = "";
      this.form.porque = "ORCAMENTO";
      //this.form.ligacao = ""
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onCaptchaVerified: function (recaptchaToken) {
    this.$refs.recaptcha.reset();
    api
        .post("/lucchesemailer/", {
          email: this.form.email,
          name: this.form.name,
          tel: this.form.tel,
          porque: this.form.porque,
          assunto: this.form.assunto,
          text: this.form.text,
          recaptchaToken: recaptchaToken,
        })
        .then((response) => {
          this.sending=false;
          if(response.status==200){
            alert("Sua mensagem foi enviada com sucesso! Aguarde nosso contato em breve.");
          }else{
            alert("Houve algum erro ao enviar sua mensagem. Por favor, tente novamente.");
          }
        })
        .catch((err) => {
          this.sending=false;
          alert("Houve algum erro ao enviar sua mensagem. Por favor, tente novamente.");
          console.log(err);
        });
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style>
.menor {
  padding-right: 20vw;
}
</style>